import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { coordinationQueryKeys } from '@/modules/coordination/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface BulkRejectCandidateJobParams {
  jobId: string;
  candidateIds: string[];
}

export const useBulkRejectCandidateJobMutation = () => {
  return useMutation({
    mutationFn: async ({
      jobId,
      candidateIds,
    }: BulkRejectCandidateJobParams) => {
      const { data } = await fetchClient.POST(
        candidateEndpoints.rejectCandidates,
        {
          params: {
            path: {
              jobId,
            },
          },
          body: { candidateIds },
        },
      );
      return data;
    },
    onSettled: (_data, _error, variables) => {
      const { jobId } = variables;
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
      invalidateQuery(coordinationQueryKeys.processes(jobId))();
    },
  });
};
